import { useState } from "react";
import API from "../API";
import './edit.css'
import {ru} from "../data/ru";
import {by} from "../data/by";

export default function Edit (props) {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdOne : by.RoleIdOne;

    const {name} = props.additional
    const api = new API();
    const [value, setValue] = useState(name);


    const editItem = (value) => {

        if (props.additional.type === 'user') {
            let resultJSON = {
                'name': value,
                'role': 'Admin'
            };
            api.editUser(props.additional.id, resultJSON).then(data => {
                props.additional.editUser(value);
                props.close();
            }).catch()
        }
        if (props.additional.type === 'organization') {
            let resultJSON = {
                'nameNewOrganization': value,
            };
            api.editOrganization(props.additional.idO, resultJSON).then(data => {
                props.additional.editOrganization();
                props.close();
            }).catch()
        }
    }

    const changeHandler = (e) => {
        setValue(e.target.value);
    }

    return (
        <div className="edit">
            <p style={{color: 'black'}}>{language.edit}:</p>
            <input className="edit-input" type='text' value={value} onChange={(e) => changeHandler(e)}/>
            <button className="edit-button" onClick={() => editItem(value)} value='submit'>{language.update}</button>
        </div>
    )
}